/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FixedAvailabilityParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('fixed')],
    ['value', codecBoolean],
]);
export class FixedAvailability extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FixedAvailabilityParser.decode(input).map(res => new FixedAvailability(res));
    }
    static unsafeDecode(input) {
        return FixedAvailability.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FixedAvailabilityParser.encode(data);
    }
    static schema() {
        return FixedAvailabilityParser.schema();
    }
}
